import styled from 'styled-components';
import media from '../../mediaqueries/media';
const PermissionBoxWrapper = styled.div`
.permissionBoxContainer  {
    position: fixed;
    top: 90px;
    right: 40px;
    width: var(--page-header-width);
    color: var(--page-header-txtColor);
    background: var(--page-header-bgColor);
    font-family:"open sans", sans-serif;
    z-index:999;
    width: 200px;
    height: 200px;
    padding: 10px;
    &.active{
      height: auto;
      padding: 0;
      margin: 0;
    }
    ${media.tablet`
    position: relative;
    right: 20px;
    width: 160px;
    height: 160px;
    top: 20px;
    margin-left: auto;
    margin-bottom: 20px;
    }
    // height: 100%;
    `}
    .audiovideoPermission{
      .header-icons{
          display: flex;
          // margin: 10px;
          justify-content:flex-end;
        .permission-control{
            width: 30px;
            height: 30px;
            margin: 0 5px;
            background-color: #fff;
            border-radius: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            &.m-off{
              background-image:url('/images/microphone-off@2x.png');
              background-repeat:no-repeat;
              background-size: 12px;
              background-position: center center;
            }
            &.v-off{
              background-image:url('/images/video-off@2x.png');
              background-repeat:no-repeat;
              background-size: 12px;
              background-position: center center;
            }
        }
      }
      .user-icon{
        position: absolute;
        max-width: 60px;
        margin: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        img{
          border-radius:50%;
        }
      }
      }
    }
    

    .permissionVerification{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      text-align: center;
      .permission-text{
        font-family: "open sans", sans-serif;
        color:#fff;
        font-size:0.8rem;  
      }
      .verify-button{
        font-family: "open sans", sans-serif;
        cursor: pointer;
        background-color:#4eb0de;
        line-height: normal;
        margin:20px 0 0;
        width: 129px;
        height: 26px;
        font-size: 0.75rem;
        border: 0;
        border-radius:10px;
        display: block;
        text-transform: uppercase;
        text-align: center;
        color: #ffffff;
        font-weight: bold;
        line-height: 1;
        &:focus{
          outlie:none;
          box-shadow:none;
        }
      }
    }

    .permissionNotGranted{
      text-align:center;
      .header-icons{
        display: flex;
        // margin: 10px;
        justify-content:center;
      }
      .no-permission-text{
        font-family: "open sans", sans-serif;
        color:#fff;
        font-size:0.8rem;  
        text-align:center;
        padding:0 10px;
        ${media.tablet`
        font-size:0.55rem;
        `}
      }
      .permission-control{
        width: 40px;
        height: 40px;
        margin: 0 5px;
        display: flex;
        align-items: center;
        justify-content: center;
          &.mike{
            background-image:url('/images/notMike.png');
            background-repeat:no-repeat;
            background-size: 32px;
            background-position: center center;
          }
          &.camera{
            background-image:url('/images/notCamera.png');
            background-repeat:no-repeat;
            background-size: 32px;
            background-position: center center;
          }
      }
      .moreInfo{
        margin:auto;
        font-size:0.75rem;  
        color:#4eb0de;
        text-transform:capitalize;
        text-decoration:underline;
        margin-top:10px;
        display:block;
      }
    }
  }

  .videoThumbnailBox{
    video{
      height: 180px;
      ${media.tablet`
      position: absolute;
      width: 150px !important;
        `}
    }
    .showControls{
      bottom: 0px !important;
      button{
        width: 35px;
        height: 20px;
      }
    }

    .initial-name{
      width: 65px;
      height: 65px;
      border-radius: 65px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #4eb0de;
      display: flex;
      align-items: center;
      justify-content: center;
      color:#fff;
      font-weight: 700;
      font-size: 30px;
      text-transform: uppercase;
    }

  }

`;


export default (PermissionBoxWrapper);